// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// AI TIER BUDGETS SCHEMA
/////////////////////////////////////////

export const AiTierBudgetsSchema = z.object({
  specializedFrontierUsd: z.number().nullable(),
  heavyweightReasoningUsd: z.number().nullable(),
  productionUtilityUsd: z.number().nullable(),
})

export type AiTierBudgets = z.infer<typeof AiTierBudgetsSchema>

export default AiTierBudgetsSchema;
